/**
 * * Модель ответа на загрузку чанка
 */
export class UploadFileChunkResponseModel {
  /**Чанк успешно загружен */
  ChunkIsSuccess: boolean = false;
  /**ID загрузки */
	UploadId!: string;
  /**ID файла */
	FileId!: number;
  
  constructor(obj?: Partial<UploadFileChunkResponseModel>) {
    Object.assign(this, obj);
  }
}